export default "__VITE_ASSET__DBjqAKJR__"